import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tgadvisory-user',
  templateUrl: './tgadvisory-user.component.html',
  styleUrls: ['./tgadvisory-user.component.scss']
})
export class TgadvisoryUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
